import { defineMessages } from 'react-intl';

export default defineMessages({
    HomeDetails: {
        id: 'policy.common.component.policy-dwelling-info.Home Details',
        defaultMessage: 'Home Details'
    },
    DistanceToFireHydrant: {
        id: 'policy.common.component.policy-dwelling-info.Distance To Fire Hydrant',
        defaultMessage: 'Distance to Fire Hydrant'
    },
    DistanceToFireStation: {
        id: 'policy.common.component.policy-dwelling-info.Distance To Fire Station',
        defaultMessage: 'Distance to Fire Station'
    },
    FeetToFireHydrant: {
        id: 'policy.common.component.policy-dwelling-info.Feet To Fire Hydrant',
        defaultMessage: '{distance} ft'
    },
    MilesToFireStation: {
        id: 'policy.common.component.policy-dwelling-info.Miles',
        defaultMessage: '{miles} miles'
    },
    FloodingorFireHazard: {
        id: 'policy.common.component.policy-dwelling-info.Flooding or Fire Hazard',
        defaultMessage: 'Flooding or Fire Hazard'
    },
    WithinftofCommercialProperty: {
        id: 'policy.common.component.policy-dwelling-info.Within 300ft of Commercial Property',
        defaultMessage: 'Within 300ft of Commercial Property'
    },
    LocationType: {
        id: 'policy.common.component.policy-dwelling-info.Location Type',
        defaultMessage: 'Location Type'
    },
    ResidenceType: {
        id: 'policy.common.component.policy-dwelling-info.Residence Type',
        defaultMessage: 'Residence Type'
    },
    Homeisusedas: {
        id: 'policy.common.component.policy-dwelling-info.Home Type',
        defaultMessage: 'Home Type'
    },
    DwellingOccupied: {
        id: 'policy.common.component.policy-dwelling-info.Dwelling Occupied',
        defaultMessage: 'Dwelling Occupied'
    },
    Mortgagee: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    MortgageeName: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee Name',
        defaultMessage: 'Name'
    },
    MortgageeStreet: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee Street',
        defaultMessage: 'Street'
    },
    MortgageeCity: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee City',
        defaultMessage: 'City'
    },
    MortgageeState: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee State',
        defaultMessage: 'State'
    },
    ConstructionDetails: {
        id: 'policy.common.component.policy-dwelling-info.Construction Details',
        defaultMessage: 'Construction Details'
    },
    YearBuilt: {
        id: 'policy.common.component.policy-dwelling-info.Year Built',
        defaultMessage: 'Year Built'
    },
    ofStories: {
        id: 'policy.common.component.policy-dwelling-info.No of Stories',
        defaultMessage: 'No. of Stories'
    },
    noOfUnits: {
        id: 'policy.common.component.policy-dwelling-info.No of Units',
        defaultMessage: 'No. of Units'
    },
    noOfTenants: {
        id: 'policy.common.component.policy-dwelling-info.No of Tenants',
        defaultMessage: 'No. of Tenant'
    },
    Garage: {
        id: 'policy.common.component.policy-dwelling-info.Garage',
        defaultMessage: 'Garage'
    },
    ConstructionType: {
        id: 'policy.common.component.policy-dwelling-info.Primary Construction Type',
        defaultMessage: 'Primary Construction Type'
    },
    SecConstructionType: {
        id: 'policy.common.component.policy-dwelling-info.Secondary Construction Type',
        defaultMessage: 'Secondary Construction Type'
    },
    FoundationType: {
        id: 'policy.common.component.policy-dwelling-info.Foundation Type',
        defaultMessage: 'Foundation Type'
    },
    RoofType: {
        id: 'policy.common.component.policy-dwelling-info.Roof Type',
        defaultMessage: 'Roof Type'
    },
    RoofUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Roof Updated',
        defaultMessage: 'Roof Updated'
    },
    PlumbingType: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Type',
        defaultMessage: 'Plumbing Type'
    },
    PlumbingUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Upgraded',
        defaultMessage: 'Plumbing Upgraded'
    },
    PrimaryHeatingType: {
        id: 'policy.common.component.policy-dwelling-info.Primary Heating Type',
        defaultMessage: 'Primary Heating Type'
    },
    SecondaryHeatingType: {
        id: 'policy.common.component.policy-dwelling-info.Secondary Heating Type',
        defaultMessage: 'Secondary Heating Type'
    },
    HeatingUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Heating Upgraded',
        defaultMessage: 'Heating Upgraded'
    },
    WiringType: {
        id: 'policy.common.component.policy-dwelling-info.Type of Wiring',
        defaultMessage: 'Type of Wiring'
    },
    ElectricalSystem: {
        id: 'policy.common.component.policy-dwelling-info.Electrical System',
        defaultMessage: 'Electrical System'
    },
    TotalTaxes: {
        id: 'policy.common.component.policy-dwelling-info.Total Taxes',
        defaultMessage: 'Total Taxes'
    },
    TotalCost: {
        id: 'policy.common.component.policy-dwelling-info.Total Cost',
        defaultMessage: 'Total Cost'
    },
    WiringUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Electrical Updated',
        defaultMessage: 'Electrical Updated'
    },
    ProtectionDetails: {
        id: 'policy.common.component.policy-dwelling-info.Protection Details',
        defaultMessage: 'Protection Details'
    },
    FireExtinguisher: {
        id: 'policy.common.component.policy-dwelling-info.Fire Extinguisher',
        defaultMessage: 'Fire Extinguisher'
    },
    BurglarAlarm: {
        id: 'policy.common.component.policy-dwelling-info.Burglar Alarm System',
        defaultMessage: 'Burglar Alarm System'
    },
    MonitoringCenterFireAlarm: {
        id: 'policy.common.component.policy-dwelling-info.Monitoring Center Fire Alarm',
        defaultMessage: 'Monitoring Center Fire Alarm'
    },
    SmokeAlarms: {
        id: 'policy.common.component.policy-dwelling-info.Smoke Alarms',
        defaultMessage: 'Smoke Alarms'
    },
    PolicyType: {
        id: 'policy.common.component.policy-dwelling-info.Policy Type',
        defaultMessage: 'Policy Type'
    },
    DeadBolts: {
        id: 'policy.common.component.policy-dwelling-info.Dead Bolts',
        defaultMessage: 'Deadbolts'
    },
    ResidenceVisibletoNeighbours: {
        id: 'policy.common.component.policy-dwelling-info.Residence Visible to Neighbours',
        defaultMessage: 'Residence Visible to Neighbours'
    },
    SprinklerSystemType: {
        id: 'policy.common.component.policy-dwelling-info.Sprinkler System',
        defaultMessage: 'Sprinkler System'
    },
    RoomersorBorders: {
        id: 'policy.common.component.policy-dwelling-info.Roomers or Borders',
        defaultMessage: 'Roomers or Borders'
    },
    ofUnits: {
        id: 'policy.common.component.policy-dwelling-info.No. of Units',
        defaultMessage: 'No. of Units'
    },
    FireplaceorWoodstove: {
        id: 'policy.common.component.policy-dwelling-info.Fireplace or Woodstove',
        defaultMessage: 'Fireplace or Woodstove'
    },
    SwimmingPool: {
        id: 'policy.common.component.policy-dwelling-info.Swimming Pool',
        defaultMessage: 'Swimming Pool'
    },
    Trampoline: {
        id: 'policy.common.component.policy-dwelling-info.Trampoline',
        defaultMessage: 'Trampoline'
    },
    FloodingWaterLeakinpastYears: {
        id: 'policy.common.component.policy-dwelling-info.Flooding/Water Leak in past 5 Years',
        defaultMessage: 'Flooding/Water Leak in past 5 Years'
    },
    SectionICoverages: {
        id: 'policy.common.component.policy-dwelling-info.Section I Coverages',
        defaultMessage: 'Section I Coverages'
    },
    SectionIICoverages: {
        id: 'policy.common.component.policy-dwelling-info.Section II Coverages',
        defaultMessage: 'Section II Coverages'
    },
    AdditionalLiabilityCoverages: {
        id: 'policy.common.component.policy-dwelling-info.Additional Liability Coverages',
        defaultMessage: 'Additional Liability Coverages'
    },
    AdditionalPropertyCoverages: {
        id: 'policy.common.component.policy-dwelling-info.Additional Property Coverages',
        defaultMessage: 'Additional Property Coverages'
    },
    infoYes: {
        id: 'policy.common.component.policy-dwelling-info.Yes',
        defaultMessage: 'Yes'
    },
    infoNo: {
        id: 'policy.common.component.policy-dwelling-info.No',
        defaultMessage: 'No'
    },
    coverages: {
        id: 'policy.common.component.policy-dwelling-info.Coverages For',
        defaultMessage: 'Coverages'
    },
    additionalNamedInsured: {
        id: 'policy.common.component.policy-dwelling-info.Additional Named Insured',
        defaultMessage: 'Additional Named Insured'
    },
    occupancyType: {
          id: 'policy.common.component.policy-dwelling-info.Occupancy Type',
          defaultMessage: 'Occupancy Type'
      },
     structureType: {
        id: 'policy.common.component.policy-dwelling-info.Structure Type',
        defaultMessage: 'Structure Type'
    },
    yearBuilt: {
        id: 'policy.common.component.policy-dwelling-info.Year Built',
        defaultMessage: 'Year Built'
    },
    noOfStories: {
        id: 'policy.common.component.policy-dwelling-info.No. Of Stories',
        defaultMessage: 'No. Of Stories'
    },
    hideCoverages: {
        id: 'policy.common.component.policy-dwelling-info.hide coverages',
        defaultMessage: 'Hide Details'
    },
    showCoverages: {
        id: 'policy.common.component.policy-dwelling-info.show coverages',
        defaultMessage: 'Show Details'
    },
    package: {
        id: 'policy.common.component.policy-dwelling-info.Package',
        defaultMessage: 'Package'
    },
    primary: {
        id: 'policy.common.component.policy-dwelling-info.Primary',
        defaultMessage: 'Primary'
    },
    showBuildingDetails: {
        id: 'policy.common.component.policy-dwelling-info.Show Building Details',
        defaultMessage: 'Show Building Details'
    },
    hotTub: {
        id: 'policy.common.component.policy-dwelling-info.Hot Tub',
        defaultMessage: 'Hot Tub'
    },
    heatingUpdated: {
        id: 'policy.common.component.policy-dwelling-info.Heating Updated',
        defaultMessage: 'Heating Updated'
    },
    estYearHeatUpdated: {
        id: 'policy.common.component.policy-dwelling-info.Est Year Heat Updated',
        defaultMessage: 'Est Year Heat Updated'
    },
    estYearElectricalUpdated: {
        id: 'policy.common.component.policy-dwelling-info.Est Year Electrical Updated',
        defaultMessage: 'Est Year Electrical Updated'
    },
    estYearRoofUpdated: {
        id: 'policy.common.component.policy-dwelling-info.Est Year Roof Updated',
        defaultMessage: 'Est Year Roof Updated'
    },
    estYearPlumbingUpdated: {
        id: 'policy.common.component.policy-dwelling-info.Est Year Plumbing Updated',
        defaultMessage: 'Est Year Plumbing Updated'
    },
    PrimaryFuelType: {
        id: 'policy.common.component.policy-dwelling-info.Primary Fuel Type',
        defaultMessage: 'Primary Fuel Type'
    },
    SecondaryFuelType: {
        id: 'policy.common.component.policy-dwelling-info.Secondary Fuel Type',
        defaultMessage: 'Secondary Fuel Type'
    },
    RoofUpdateType: {
        id: 'policy.common.component.policy-dwelling-info.Roof Update Type',
        defaultMessage: 'Roof Update Type'
    },
    RoofMaterial: {
        id: 'policy.common.component.policy-dwelling-info.Roof Material',
        defaultMessage: 'Roof Material'
    },
    ElectricalUpdateType: {
        id: 'policy.common.component.policy-dwelling-info.Electrical Update Type',
        defaultMessage: 'Electrical Update Type'
    },
    ElectricalServiceAmp: {
        id: 'policy.common.component.policy-dwelling-info.Electrical Service Amp',
        defaultMessage: 'Electrical Service Amp'
    },
    PanelType: {
        id: 'policy.common.component.policy-dwelling-info.Panel Type',
        defaultMessage: 'Panel Type'
    },
    StandbyGenerator: {
        id: 'policy.common.component.policy-dwelling-info.Stand by Generator',
        defaultMessage: 'Stand by Generator'
    },
    OtherWiring: {
        id: 'policy.common.component.policy-dwelling-info.Other Wiring',
        defaultMessage: 'Other Wiring'
    },
    BuildingSurgeProtection: {
        id: 'policy.common.component.policy-dwelling-info.Building Surge Protection',
        defaultMessage: 'Building Surge Protection'
    },
    PlumbingUpdated: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Updated',
        defaultMessage: 'Plumbing Updated'
    },
    BuildingDetails: {
        id: 'policy.common.component.policy-dwelling-info.Building Details',
        defaultMessage: 'Building Details'
    },
    PlumbingUpdateType: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Update Type',
        defaultMessage: 'Plumbing Update Type'
    },
    PlumbingUpdatedYear: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Updated Year',
        defaultMessage: 'Plumbing Updated Year'
    },
    PlumbingSupplyType: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Supply Type',
        defaultMessage: 'Plumbing Supply Type'
    },
    SumpPump: {
        id: 'policy.common.component.policy-dwelling-info.Sump Pump',
        defaultMessage: 'Sump Pump'
    },
    DrainType: {
        id: 'policy.common.component.policy-dwelling-info.Drain Type',
        defaultMessage: 'Drain Type'
    },
    Coverages: {
        id: 'policy.common.component.policy-dwelling-info.Coverages',
        defaultMessage: 'Coverages'
    },
    BasementFinished: {
        id: 'policy.common.component.policy-dwelling-info.Basement Finished',
        defaultMessage: 'Basement Finished'
    },
    Heating: {
        id: 'policy.common.component.policy-dwelling-info.Heating',
        defaultMessage: 'Heating'
    },
    Protection: {
        id: 'policy.common.component.policy-dwelling-info.Protection',
        defaultMessage: 'Protection'
    },
    Structure: {
        id: 'policy.common.component.policy-dwelling-info.Structure',
        defaultMessage: 'Structure'
    },
    Electrical: {
        id: 'policy.common.component.policy-dwelling-info.Electrical',
        defaultMessage: 'Electrical'
    },
    Plumbing: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing',
        defaultMessage: 'Plumbing'
    },
    Occupancy: {
        id: "policy.ho.directives.policy-dwelling-info.Property/Occupancy Type",
        defaultMessage: "Property/Occupancy Type"
    },
    NoOfRommerAndBoarders: {
        id: "policy.ho.directives.policy-dwelling-info.No.of Roomers and Boarders",
        defaultMessage: "No.of Roomers and Boarders"
    },
});
